import { render, staticRenderFns } from "./stu_update_more.vue?vue&type=template&id=639d6588&scoped=true"
import script from "./stu_update_more.vue?vue&type=script&lang=js"
export * from "./stu_update_more.vue?vue&type=script&lang=js"
import style0 from "./stu_update_more.vue?vue&type=style&index=0&id=639d6588&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d6588",
  null
  
)

export default component.exports